import { render, staticRenderFns } from "./InviteFriendsToWinAwardsList.vue?vue&type=template&id=6d0be6f9&scoped=true"
import script from "./InviteFriendsToWinAwardsList.vue?vue&type=script&lang=js"
export * from "./InviteFriendsToWinAwardsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0be6f9",
  null
  
)

export default component.exports